import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import React, { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ManagerPortalHeader } from './ManagerPortalHeader';
import { ManagerPortalSidebar } from './ManagerPortalSidebar';
import '../../template/AttendanceTrackingLayout/index.scss';

const STORAGE_KEY = 'manager-portal-sidebar-collapsed';

export const ManagerPortalLayout = () => {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === 'true'
  );

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, String(next));
      return next;
    });
  }, []);

  return (
    <>
      <ManagerPortalHeader />
      <div
        className={`attendance-tracking-layout ${
          collapsed ? 'attendance-tracking-layout--collapsed' : ''
        }`}
      >
        <ManagerPortalSidebar collapsed={collapsed} />
        <button
          type="button"
          className="attendance-tracking-layout__rail"
          onClick={toggleCollapsed}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-expanded={!collapsed}
        >
          {collapsed ? (
            <ChevronRightIcon fontSize="small" />
          ) : (
            <ChevronLeftIcon fontSize="small" />
          )}
        </button>
        <main className="attendance-tracking-content">
          <Outlet />
        </main>
      </div>
    </>
  );
};
